import React, { useContext } from 'react';
import LocalizationContext from '../../contexts/Localizations';
import { Team as TeamDetailsProps } from '../../core/typings/riders';
import { Container } from '../helpers/Grid';
import './styles.scss';

const TeamDetails = ({
  teamCode,
  teamName,
  categoryName,
  country,
  website,
  email,
  pictureTeamJersey,
  address,
}: TeamDetailsProps) => {
  const { translations } = useContext(LocalizationContext);

  return (
    <div className={`team-details ${pictureTeamJersey ? 'team-details--with-image' : ''}`}>
      <Container>
        <div className="team-details__inner">
          <div className="team-details__body">
            <div className="team-details__name">
              {teamName}
            </div>
            <div className="team-details__details">
              {`
                ${categoryName && `${categoryName} -`}
                ${teamCode && `${teamCode} -`}
                ${country && country.replace('BELARUS', '*******').replace('RUSSIAN FEDERATION', '*******')}
              `}
            </div>
            <div className="team-details__contact">
              <div className="team-details__website">
                {website && (
                  <div className="team-details__feild">
                    <span>{translations.competition.websiteLabel}</span>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a
                      href={website.url}
                      target={website.isExternal ? '_blank' : '_self'}
                      rel={website.isExternal ? 'noopener noreferrer' : ''}
                    >
                      {website.title}
                    </a>
                  </div>
                )}
                {email && (
                  <div className="team-details__feild">
                    <span>{translations.competition.emailLabel}</span>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a
                      href={email.url}
                      target={email.isExternal ? '_blank' : '_self'}
                      rel={email.isExternal ? 'noopener noreferrer' : ''}
                    >
                      {email.title}
                    </a>
                  </div>
                )}
              </div>
              {address && (
                <div className="team-details__address">
                  <div className="team-details__feild">
                    <span>{translations.competition.addressLabel}</span>
                    <address>
                      {Object.values(address).map((line) => (
                        <>
                          {line}
                          <br />
                        </>
                      ))}
                    </address>
                  </div>
                </div>
              )}
            </div>
          </div>
          {pictureTeamJersey && (
            <div className="team-details__image">
              <img src={pictureTeamJersey} alt={teamName} />
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default TeamDetails;
